export default "__VITE_ASSET__Bz45Thf7__"